import { Space, Typography, Button } from "antd";
import { Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import * as Yup from "yup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  createCompanyInfo,
  updateCompanyInfo,
} from "../../store/api/companyInfo";

const { Text } = Typography;

const InfoForm = ({ infoKey, companyInfo, refetch }) => {
  const formikRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const initialValues = {
    [infoKey]: companyInfo ? companyInfo[infoKey] : null,
  };

  const validationSchema = Yup.object({
    [infoKey]: Yup.mixed(),
  });

  const onSubmit = (values) => {
    setLoading(true);

    if (companyInfo?.id) {
      const data = {
        [infoKey]: values[infoKey],
        id: companyInfo.id,
      };

      updateCompanyInfo(companyInfo.id, data)
        .then(() => {
          refetch();
          formikRef.current.resetForm({ values });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      const data = {
        [infoKey]: values[infoKey],
      };

      createCompanyInfo(data)
        .then(() => {
          refetch();
          formikRef.current.resetForm({ values });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          dirty,
          errors,
          touched,
          values,
          handleChange,
          setFieldValue,
          resetForm,
        }) => {
          return (
            <Form>
              <div style={{ marginBottom: "0.5rem" }}>
                <Text type="secondary">
                  Note: If you need to add images in the content, please use
                  images of size <strong>smaller than 200KB</strong>. Using
                  larger images may result in error
                </Text>
              </div>
              <Space direction="vertical" style={{ width: "100%" }} size={20}>
                <div>
                  <ReactQuill
                    theme="snow"
                    value={values[infoKey]}
                    onChange={(value) => setFieldValue(infoKey, value)}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, 3, 4, false] }],
                        ["bold", "italic", "underline", "strike", "blockquote"],
                        [
                          { list: "ordered" },
                          { list: "bullet" },
                          { indent: "-1" },
                          { indent: "+1" },
                        ],
                        ["link", "image"],
                        ["clean"],
                      ],
                    }}
                    formats={[
                      "header",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "blockquote",
                      "list",
                      "bullet",
                      "indent",
                      "link",
                      "image",
                    ]}
                  />
                  {errors[infoKey] && touched[infoKey] ? (
                    <Text type="danger">{errors[infoKey]}</Text>
                  ) : null}
                </div>
                <div style={{ display: "flex", gap: "14px", flexWrap: "wrap" }}>
                  <Button
                    type="secondary"
                    htmlType="button"
                    disabled={!dirty || loading}
                    onClick={resetForm}
                  >
                    Cancel
                  </Button>
                  <Button
                    loading={loading}
                    type="primary"
                    htmlType="submit"
                    disabled={!dirty || loading}
                  >
                    Save
                  </Button>
                </div>
              </Space>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default InfoForm;
